import React from 'react';
import { ExtensionPointRenderer } from '@go-client/go-modules/core/ExtensionPoints/Renderers/index';
import { ContextExtensionModule } from '@go-shared/types/go-modules/goModules';

/* DefaultRenderer will call module.render() method */
export class DefaultRenderer implements ExtensionPointRenderer {
  render(ctxExtensionModules: ContextExtensionModule[], data: any, events: any): JSX.Element {
    if (ctxExtensionModules.length) {
      return (
        <>
          {ctxExtensionModules.map(element => (
            <React.Fragment key={element.name}>
              {element.componentInstance?.renderFn(element, data, events)}
            </React.Fragment>
          ))}
        </>
      );
    }

    return <></>;
  }
}
